module.exports = __webpack_public_path__ + "static/img/product3.f0752a51.png";